export default {
  1: {
    offerId: '637b9648-44eb-11e8-9c02-c32aef44dd4f', // Personal Capital
  },
  2: {
    offerId: '61f89e9c-44eb-11e8-9c02-47cba4714c38', // Betterment
  },
  7: {
    offerId: '637627f8-44eb-11e8-9c02-23e9d619b8d2', // Motif Investing
  },
  24: {
    offerId: '6377fd9e-44eb-11e8-9c02-0b24096a7862', // FutureAdvisor
  },
  31: {
    offerId: '6382e3b2-44eb-11e8-9c02-7754be2f52a2', // Wealthfront
    disclaimer: 'wealthfront',
  },
  32: {
    offerId: '63816230-44eb-11e8-9c02-c793fc79eaf7', // WiseBanyan
  },
  34: {
    offerId: '61fddf74-44eb-11e8-9c02-1be0cc51d67a', // Blooom
  },
  35: {
    offerId: '6379d768-44eb-11e8-9c02-4b2961b3581b', // Vanguard Personal Advisor Services
  },
  127: {
    offerId: '61f333ee-44eb-11e8-9c02-c3322ff87ac8', // Acorns
  },
  156: {
    offerId: '637e6300-44eb-11e8-9c02-ebce30ae2d87', // Schwab - Intelligent Portfolios
  },
  187: {
    offerId: '6370d014-44eb-11e8-9c02-8b921b587602', // NW / FeeX
  },
  208: {
    offerId: '636d4b38-44eb-11e8-9c02-4f287d828ca6', // Fidelity Go
  },
  212: {
    offerId: '636f045a-44eb-11e8-9c02-ef399bea81a8', // Stash Invest
  },
  240: {
    offerId: '636b85b4-44eb-11e8-9c02-6794376cdc54', // TD Ameritrade Essential Portfolios
  },
  310: {
    offerId: '637d0212-44eb-11e8-9c02-2711cd0e822b', // Merrill Edge Guided Investing
  },
  311: {
    offerId: '63728cf6-44eb-11e8-9c02-df8289f4de7e', // Schwab - Intelligent Advisory
  },
  345: {
    offerId: '61f0e8e6-44eb-11e8-9c02-9fe35668fa6b', // ElleVest
  },
  355: {
    offerId: '63845512-44eb-11e8-9c02-37fd94711402', // Wealthsimple
  },
};
